import { render, staticRenderFns } from "./ShareModel.vue?vue&type=template&id=0b5cac84&scoped=true"
import script from "./ShareModel.vue?vue&type=script&lang=js"
export * from "./ShareModel.vue?vue&type=script&lang=js"
import style0 from "./ShareModel.vue?vue&type=style&index=0&id=0b5cac84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5cac84",
  null
  
)

export default component.exports